import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=1ab12b52&"
import script from "./uploadImage.vue?vue&type=script&lang=js&"
export * from "./uploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports